import type { Scale2d } from "@logic/lib/2d"
import type {
  Panel,
  Equipment as EquipmentTypeInferredFromZod,
} from "@logic/lib/design"
import { MODULE_POWUR_OS_EQUIPMENT_ID } from "@logic/lib/powur-os"
import { scalePanelToImage } from "@logic/lib/utils"

import { designRemoteState } from "~/containers/Proposal/state/designs/design-state"
import { allEquipmentForSiteState } from "~/containers/Proposal/state/equipment/equipment-state"
import { siteLocalState } from "~/containers/Proposal/state/site/site-state"

import type { TransactionOperation } from "."
import { getPreferredImage } from "./getPreferredImage"
import { selectedModuleState } from "../panels"

export const getPanelScale: TransactionOperation<
  (Panel & { gap: number }) | null,
  Scale2d
> = (transactors, panel = null) => {
  const { get } = transactors

  // cannot use selectors within transactions - this is a limitation of Recoil
  // as of 8.7.23
  // workaround: retrieve the atom state and recreate the filter here
  const allEquipment = get(allEquipmentForSiteState)

  const design = get(designRemoteState)
  // const { solarModule: selectedModule } = design
  const selectedModule = get(selectedModuleState)
  const availableModules = allEquipment
    .filter((item) => item.typeId === MODULE_POWUR_OS_EQUIPMENT_ID)
    .map((item) => ({
      ...item,
      visionId: String(item.id),
    })) as {
    width: number
    height: number
    visionId: string
    id: number
  }[]
  if (selectedModule) {
    availableModules.push(selectedModule)
  }

  const solarModule = panel
    ? (availableModules.find((m) => m.visionId === panel.module) ??
      selectedModule)
    : selectedModule

  if (!solarModule) throw new Error(`No solar module selected`)

  const { latitude } = get(siteLocalState)
  const { zoomLevel } = getPreferredImage(transactors)

  const dimensionsWithGap = {
    height: (solarModule.height ?? 0) + (panel?.gap ?? 1) * 2,
    width: (solarModule.width ?? 0) + (panel?.gap ?? 1) * 2,
  }

  // console.log({ solarModule, dimensionsWithGap, gap: panel?.gap })

  return scalePanelToImage({
    solarModule: {
      ...solarModule,
      ...dimensionsWithGap,
    },
    latitude,
    zoomLevel,
  })
}
